import PageTransition from "../components/PageTransition.js";
import styled from "styled-components";

import dnaImg from "../assets/images/dna.jpeg";
import employersIcon from "../assets/images/employersIcon.svg";
import individualIcon from "../assets/images/individualIcon.svg";
import productIcon from "../assets/images/productIcon.svg";
import radarDiagram from "../assets/images/radarDiagram.png";

import { device } from "../styles/Responsive.style.js";
import AttributeInfo from "../components/Modals/AttributeInfo.js";
import Carousel from "../components/Carousel.js";
import { useState } from "react";
import { FormButton, PrimaryButton, SecondaryButton } from "../styles/Button.styles.js";
import { useUser } from "../context/UserContext.js";
import AttributeBox from "../components/AttributeBox.js";
import { Link } from "react-router-dom";

const Home = () => {
    const [moreInfo, setMoreInfo] = useState(false);

    const { setShowContactForm } = useUser();



    return (
        <>
            <Hero bgImg={dnaImg}>
                <h1>attri<b>DNA</b></h1>
                <h2>Discovering your potential.</h2>
            </Hero>

            <main>
                <Section>
                    <LimitWidth>
                        <TextWrapper>
                            <h3 className="white">Welcome to attriDNA</h3>
                            <p>A pioneering online tool designed to identify the core attributes essential for success in a variety of digital roles.</p>
                            <p>attriDNA is an attribute based diagnostic that reveals how people think, solve problems, and collaborate, the traits that drive performance in the digital era.</p>
                            <p>In a world where AI and prompt engineering are becoming increasingly important, attriDNA also recognises the value of human skills such as growth mindset, adaptability, and communication style - the qualities that help people thrive alongside technology.</p>
                            <p>Whether you’re an individual exploring your career potential, or an employer developing digital skills and capabilities, attriDNA turns data into actionable insights.</p>
                        </TextWrapper>
                        {/* <MainLink to="/invite/6d60cafd-7d1a-4ba8-87eb-b1c773cf3776/67975916d5bd89aed03abbd2">Join now</MainLink> */}
                    </LimitWidth>
                </Section>
                <Section>
                    <LimitWidth>
                        <div className="sideBySide">
                            <ImgWrapper className="imgWrap">
                                <img src={individualIcon} alt="individual icon"/>
                            </ImgWrapper>
                            <TextWrapper>
                                <h3>For Individuals</h3>
                                <p>Find your Digital DNA, we all have it - Discover what will make you stand out!</p>
                                <p>Complete the attriDNA questionnaire to uncover your natural strengths and how they align with in-demand digital roles.</p>
                                <h4>Learn where your attributes can take you.</h4>
                                <Link to="/individuals">
                                    <PrimaryButton>Click Here</PrimaryButton>
                                </Link>
                            </TextWrapper>
                        </div>
                        <div className="sideBySide">
                            <ImgWrapper className="imgWrap">
                                <img src={employersIcon} alt="company building"/>
                            </ImgWrapper>
                            <TextWrapper>
                                <h3>For Employers</h3>
                                <p>See the hidden talent in your workforce … or identify potential in external hires!</p>
                                <p>attriDNA helps you identify and develop the attributes that drive digital performance, inside your existing teams or future hires.</p>
                                <h4>Discover how.</h4>
                                <Link to="/employers">
                                    <PrimaryButton>Click Here</PrimaryButton>
                                </Link>
                            </TextWrapper>
                        </div>
                    </LimitWidth>
                </Section>
                <Section>
                    <LimitWidth className="textLeft">
                        <TextWrapper className="left">
                            <h3>Introducing attriDNA</h3>
                            <p>attriDNA is a groundbreaking online diagnostic that identifies the <b>core attributes essential for success in digital roles</b>— helping individuals understand their strengths and enabling employers to uncover the hidden potential within their teams or potential new hires.</p>
                            <p>Developed in collaboration with <b>industry leaders and testing specialists</b>, attriDNA has been validated across sectors including major financial institutions and global technology firms. With insights from <b>over a thousand individuals</b>, the results speak for themselves:</p>
                            <p>“We were amazed to discover so many potential software developers within our own business.”</p>
                            <p>attriDNA doesn’t just assess skills — it reveals the <b>underlying attributes</b> that drive performance: problem-solving, critical thinking, adaptability, resilience, and teamwork.</p>
                            <p>The tool can be configured for both <b>individual development</b> and <b>organisational insight</b>, identifying colleagues who could thrive in roles such as: Business Analyst, Data Analyst, Project Manager, Network Engineer, Cyber Security Analyst, Software Developer, Prompt Engineer, or Service Desk Analyst.</p>
                        </TextWrapper>
                        <ImgWrapper>
                            <img src={productIcon} alt="individual icon"/>
                        </ImgWrapper>
                    </LimitWidth>
                </Section>
                <Carousel />
                <Section>
                    <LimitWidth>
                        <TextWrapper className="center benefits">
                            <h3>Product Benefits</h3>
                            <section>
                                <div>
                                    <h4>Discover Untapped Potential</h4>
                                    <p>Reveal employees who already possess the attributes needed to thrive in digital roles — often hidden in unexpected parts of your organisation such as operations, finance, or support.</p>
                                </div>
                                <div>
                                    <h4>Bridge the Skills Gap</h4>
                                    <p>Transform your workforce from within, reducing reliance on external recruitment and lowering hiring costs.</p>
                                </div>
                                <div>
                                    <h4>Accelerate Digital Transformation</h4>
                                    <p>Equip your organisation with the digital attributes needed to compete and innovate in a rapidly changing market.</p>
                                </div>
                                <div>
                                    <h4>Enhance Engagement and Retention</h4>
                                    <p>Foster growth and loyalty by providing employees with meaningful career insights and development opportunities.</p>
                                </div>
                                <div>
                                    <h4>Research-Backed and Customisable</h4>
                                    <p>Built from real-world data and adaptable to your organisation’s specific roles, culture, and competency model.</p>
                                </div>
                            </section>
                        </TextWrapper>
                    </LimitWidth>
                </Section>
                {/* <Section>
                    <LimitWidth>
                        <TextWrapper className="center">
                            <h3>The Data</h3>
                            <p>attriDNA turns results into <b>powerful visual insights</b>. Your unique attribute profile is plotted on an interactive <b>radar chart</b>, giving you a clear picture of where your natural strengths lie — and which areas offer the greatest opportunity for growth.</p>
                            <p>Compare your results against <b>industry or population averages</b> to understand how your attributes stack up against others in the digital economy. These insights pinpoint what makes you stand out, highlight areas for development, and guide your next steps — whether that’s building confidence in your current role, preparing for progression, or exploring new career paths.</p>
                            <p>For employers, aggregated results reveal <b>team-level trends and gaps</b>, allowing you to identify hidden talent, build balanced teams, and make data-led decisions about recruitment and upskilling.</p>
                        </TextWrapper>
                    </LimitWidth>
                </Section>
                <Section>
                    <LimitWidth>
                        <TextWrapper className="center">
                            <h3>Why attriDNA?</h3>
                            <section>
                                <div>
                                    <h4>1. Attribute Complexity</h4>
                                    <p>Unlike many competitors, attriDNA focuses on assessing complex, multi-dimensional attributes such as emotional intelligence, adaptability, and resilience, which go beyond simple cognitive skills or technical ability. This complexity allows for a more holistic view of an individual’s fit for digital roles.</p>
                                </div>
                                <div>
                                    <h4>2. Tailored Role Specific Guidance</h4>
                                    <p>attriDNA provides customised role alignment, offering tailored pathways into specific digital careers, such as cybersecurity, software development, and project management. This is unlike broader, generic career guidance tools which may not align closely with industry specific needs.</p>
                                </div>
                                <div>                           
                                    <h4>3. Attribute Driven Decision Making</h4>
                                    <p>Rather than just focusing on aptitude, attriDNA emphasises behavioural and emotional attributes that are increasingly critical for success in digital roles. This allows organisations to find candidates who not only have the technical skills but also possess the attributes to thrive in dynamic and evolving digital environments.</p>
                                </div> 
                                <div>                            
                                    <h4>4. Integration of Soft Skills</h4>
                                    <p>attriDNA integrates soft skills assessments into its framework, helping organisations identify candidates who are strong in teamwork, communication, and leadership — essential skills for digital roles that often require collaboration and innovation.</p>
                                </div>
                                <div>                           
                                    <h4>5. Technology and AI Integration</h4>
                                    <p>By leveraging AI-driven tools to refine attribute-based matching, attriDNA offers precise recommendations on career pathways and upskilling options, making it highly relevant for digital and technology driven industries.</p>
                                </div>
                                <div>                            
                                    <h4>6. Flexibility for Non-Technical Candidates</h4>
                                    <p>attriDNA’s model is designed to assess candidates with limited technical experience, guiding them into suitable digital roles based on their inherent attributes, providing a pathway for individuals to transition into tech even from non-technical backgrounds.</p>
                                </div>
                            </section>
                        </TextWrapper>
                    </LimitWidth>
                </Section> */}
                <SmallWrapper>
                    <Banner>
                        <h2>Why attriDNA & More</h2>
                        <Link to="/whyAttri">
                            <SecondaryButton>
                                Click Here
                            </SecondaryButton>
                        </Link>
                    </Banner>
                </SmallWrapper>
                {/* <Section>
                    <LimitWidth className="textLeft attributes">
                        <TextWrapper className="left">
                            <h3>The Attributes</h3>
                            <p>attriDNA was created with 4 base elements:
                                <br/><br/>1 - WAY - The traits that describe how people approach their work, their attitude and motivating forces
                                <br/>2 - KNOW - Knowledge based traits relating to how people understand and learn
                                <br/>3 - HUMAN - The way people interact and collaborate with others, teams and customers
                                <br/>4 - THINK - Traits that describe how people think about the world around them and the tasks they focus on
                                <br/><br/>The four base elements have been split into 10 Attribute Categories that make up the attriDNA foundations, and it’s these categories which each question relates to.
                            </p>
                        </TextWrapper>
                        <RightSection>
                            <AttributeBox oldQuiz={false} />
                        </RightSection>
                    </LimitWidth>
                </Section> */}
                <ContactSection>Want to know more, or get an account?<br/><FormButton onClick={() => setShowContactForm(true)}>Get In Touch</FormButton></ContactSection>
            </main>

            <AttributeInfo showModal={moreInfo} setShowModal={setMoreInfo}/>

            <PageTransition isLoading={false}/>
        </>
    )
}

export default Home;

const Hero = styled.header`
    position: relative;
    width: 100vw;
    height: 600px;
    background-image: url(${props => props.bgImg});
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 90px;
    box-sizing: border-box;

    h1, b, h2 {
        color: white;
        margin: 0;
        position: relative;
    }
    h1 {
        font-size: calc(var(--font-large) * 1.8);
        font-weight: 400;
    }

    h2 {
        font-size: var(--font-large);
        font-weight: 400;
    }

    &::before {
        content: "";
        position: absolute;
        background: linear-gradient(90deg, rgba(0, 0, 0, 0.80) 0%, rgba(0, 0, 0, 0.00) 100%);
        height: 100%;
        width: 100%;
        left: 0;
    }

    @media ${device.medium} {
        height: 500px;
    }

    @media ${device.small} {
        height: 400px;
        padding: 0 30px;
        h1 {
            font-size: calc(var(--font-large) * 1.5);
        }

        h2 {
            font-size: calc(var(--font-large) * 0.8);
        }
    }
`;

const Section = styled.section`
    width: 100vw;
    padding: 20px 50px;
    height: auto;
    display: flex;
    justify-content: center;
    box-sizing: border-box;

    &:nth-child(even) {
        background-color: var(--primary-gray);
    }

    &:has(.radar) {
        background-color: var(--primary-gray);
    }

    &:has(.attributes) {
        background-color: var(--bg-main);
    }


    @media ${device.large} {
        height: auto;

        .textLeft {
            flex-direction: column-reverse;
        }
        .attributes {
            flex-direction: column;
            margin: 20px 0;
        }
    }

    @media ${device.medium} {
        padding: 0 20px;
    }

    @media ${device.small} {
        height: auto;

        .textLeft {
            flex-direction: column-reverse;
        }
        .attributes {
            flex-direction: column;
            margin: 20px 0;
        }
    }
`;

const RightSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    & > p {
        color: var(--blue);
        cursor: pointer;
        margin: 10px 0 0;

        &:hover {
            text-decoration: underline;
        }
    }
`;

const LimitWidth = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 1500px;
    padding: 0 50px;

    .left {
        margin-right: 100px;
    }
    .right {
        margin-left: 100px;
    }
    .radar {
        max-width: 380px;
    }

    .center {
        text-align: center;
        margin: 0;
        h4 {
            margin-bottom: 0;
        }
        p {
            margin-top: 0;
        }
    }

    &:has(.sideBySide) {
        gap: 50px;
    }
    .sideBySide {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        height: 100%;
        text-align: center;

        .imgWrap {
            max-width: 150px;
            margin: 20px 0;
        }

        h3 {
            text-align: center;
        }

        div {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
    }

    @media ${device.large} {
        flex-direction: column;
        padding: 0 50px;
        &:has(.sideBySide) {
            flex-direction: row;
        }
        .radar {
            max-width: 240px;
        }
        .left {
            margin-right: 0px;
        }
        .right {
            margin-left: 0px;
        }
        &.attributes {
            flex-direction: column-reverse;
        }
    }

    @media ${device.medium} {
        padding: 0;
    }

    @media ${device.small} {
        flex-direction: column;
        justify-content: center;
        &:has(.sideBySide) {
            flex-direction: column;
        }
        .radar {
            max-width: 480px;
        }
    }
`;

const TextWrapper = styled.div`
    h3 {
        font-size: var(--font-large);
        margin: 0;
        color: var(--accent);
    }
    p {
        font-size: var(--font-small);
        color: var(--text-main);
    }

    h3.white {
        font-size: var(--font-large);
        margin: 0;
        color: white;

        b {
            color: var(--accent);
        }
    }

    &:has(section) section {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin: 15px 0;
    }

    &.benefits section {
        justify-content: center;
    }

    &.center section div {
        width: calc(50% - 5px);
        box-sizing: border-box;
        padding: 0px 18px 18px;
        background: var(--bg-main-light);
        border-radius: 10px;
    }

    &.center section h4 {
        margin-bottom: 10px;
        font-size: var(--font-medium);
    }

    &.center.benefits section div h4 {
        color: var(--text-main);
    }

    @media ${device.small} {
        & {
            padding: 40px 0;
        }
        h3 {
            text-align: center;
        }
        p {
            text-align: center;
        }

        &.center section div {
            width: 100%;
            margin-bottom: 15px;
        }
    }
`;

const ImgWrapper = styled.div`
    width: 100%;
    max-width: 320px;
    margin: 50px 0;

    img {
        width: 100%;
    }

    @media ${device.large} {
        height: auto;
        max-width: 180px;
        margin: 10px 0;
    }

    @media ${device.small} {
        display: flex;
        justify-content: center;
        margin: 20px 0;

        img {
            width: 50%;
        }
    }
`;

const ContactSection = styled.h4`
    text-align: center;
    font-size: var(--font-medium);
    padding: 25px 0;
    margin: 0;
    background-color: var(--primary-gray);

    button {
        position: static;
        transform: translateX(0);
    }

    @media ${device.small} {
        font-size: calc(var(--font-medium) * 1.25);
    }
`;

const MainLink = styled(Link)`
    flex-shrink: 0;
    margin-left: 100px;
    padding: 10px 50px;
    border: none;
    border-radius: 5px;
    background-color: var(--accent);
    font-size: var(--font-small);
    text-decoration: none;
    font-weight: 900;
    color: white;
    cursor: pointer;
    letter-spacing: 1px;
    transition: all 0.2s;

    &:hover {
        background-color: var(--accent-hover);
    }

    @media ${device.medium} {
        margin: 30px 0;
    }
`;

const Banner = styled.div`
    border-radius: 10px;
    background: linear-gradient(45deg, var(--accent), var(--orange));
    display: grid;
    place-items: center;
    padding: 40px 10px;

    h2 {
        margin: 0;
        font-size: var(--font-medium);
    }

    a {
        background: white;
        color: black;
        text-decoration: none;
        padding: 5px;
        border-radius: 10px;
        margin-top: 20px;
    }
`;

const SmallWrapper = styled.div`
    width: 100%;
    max-width: 1500px;
    box-sizing: border-box;
    margin: 0 auto;
    margin-bottom: 20px;
`